/* Vassity: variant media filter — show only general media + the selected variant's media group
   in the product gallery (main slider + thumbnails). Groups come from media order:
   a variant's featured media starts its group; media before the first variant-featured media are general.
   2026-10-26: when the snippet sends "galleries" (variant id -> its custom.variant_gallery media ids), each variant shows
   exactly its own gallery plus any media that is in no gallery (per-size+colour sets). */
(function () {
  function patch() {
    var MG = customElements.get('media-gallery');
    if (!MG) return false;
    var P = MG.prototype;
    if (P.__vmf) return true;
    P.__vmf = true;
    var origInit = P.init, origSet = P.setActiveMedia, origSort = P.sortMediaItems;

    P.vmfData = function () {
      if (this._vmfData !== undefined) return this._vmfData;
      this._vmfData = null;
      var sec = this.closest('.shopify-section');
      var el = sec && sec.querySelector('script[data-variant-media-filter]');
      if (!el) return null;
      try {
        var d = JSON.parse(el.textContent);
        if (d.galleries) {
          var gal = {}, inAny = {}, firsts = {};
          Object.keys(d.galleries).forEach(function (k) {
            var list = (d.galleries[k] || []).map(String), set = {};
            list.forEach(function (id) { set[id] = 1; inAny[id] = 1; });
            if (list.length) { firsts[list[0]] = 1; gal[k] = { set: set, list: list }; }
          });
          if (!Object.keys(gal).length) return null;
          d.gal = gal; d.inAny = inAny; d.firsts = firsts; d.group = {};
          this._vmfData = d;
          return d;
        }
        var feat = {};
        Object.keys(d.variants).forEach(function (k) { if (d.variants[k]) feat[String(d.variants[k])] = 1; });
        if (!Object.keys(feat).length) return null;
        var group = {}, cur = 'g';
        d.media.forEach(function (id) { id = String(id); if (feat[id]) cur = id; group[id] = cur; });
        d.group = group;
        this._vmfData = d;
      } catch (e) { this._vmfData = null; }
      return this._vmfData;
    };

    P.vmfWrappers = function () {
      return [this.querySelector('[id^="Slider-Gallery"]'), this.querySelector('[id^="Slider-Thumbnails"]')];
    };

    P.vmfApply = function (variantId) {
      var d = this.vmfData();
      if (!d) return null;
      var f = d.variants[String(variantId)];
      f = f ? String(f) : null;
      var g = d.group;
      var allow = function (el) {
        var id = String(el.dataset.mediaId || el.dataset.target || '');
        if (!f || !(id in g)) return true;
        return g[id] === 'g' || g[id] === f;
      };
      if (d.gal) {
        var vg = d.gal[String(variantId)];
        f = vg ? (f && vg.set[f] ? f : vg.list[0]) : null;
        allow = function (el) {
          var id = String(el.dataset.mediaId || el.dataset.target || '');
          if (!vg || !d.inAny[id]) return true;
          return !!vg.set[id];
        };
      }
      var self = this, ws = this.vmfWrappers();
      if (!this._vmfItems) {
        this._vmfItems = ws.map(function (w) { return w ? Array.prototype.slice.call(w.children) : []; });
        this.setAttribute('data-vmf', '');
        // Preload each variant's first photo (and its thumb) so switching shows it instantly.
        this._vmfItems.forEach(function (list) {
          list.forEach(function (el) {
            var id = String(el.dataset.mediaId || el.dataset.target || '');
            if ((g[id] && g[id] === id) || (d.firsts && d.firsts[id])) Array.prototype.forEach.call(el.querySelectorAll('img'), function (im) { im.loading = 'eager'; });
          });
        });
      }
      var slider = this.sliderInstance && this.sliderInstance.slider;
      ws.forEach(function (w, i) {
        if (!w) return;
        var items = self._vmfItems[i];
        if (i === 0 && !slider) items = Array.prototype.slice.call(w.children).concat(items.filter(function (el) { return !el.parentNode; }));
        var keep = items.filter(allow);
        var cur = Array.prototype.slice.call(w.children);
        if (cur.length === keep.length && cur.every(function (c, j) { return c === keep[j]; })) return;
        items.forEach(function (el) { if (el.parentNode === w) w.removeChild(el); });
        keep.forEach(function (el) { w.appendChild(el); });
      });
      this.vmfRefresh();
      this._vmfVariant = String(variantId);
      return f;
    };

    P.vmfRefresh = function () {
      var t = this.thumbsInstance && this.thumbsInstance.slider;
      var s = this.sliderInstance && this.sliderInstance.slider;
      try { if (t && !t.destroyed && t.initialized) { t.update(); } } catch (e) {}
      try {
        if (s && !s.destroyed && s.initialized) {
          s.update();
          if (s.activeIndex >= s.slides.length) s.slideTo(0, 0, false);
          if (s.thumbs && s.thumbs.update) s.thumbs.update(true);
          if (s.params.autoHeight) s.updateAutoHeight(0);
        }
      } catch (e) {}
      // Zoom: lightbox walks only the visible media, in slider order.
      var gal = this;
      if (this.lightbox && !this.lightbox.__vmf) {
        // Theme opens zoom with the media's original index; map it to its place among the visible media.
        var lb = this.lightbox, origOpen = lb.loadAndOpen.bind(lb);
        lb.__vmf = true;
        lb.loadAndOpen = function (index, dataSource, point) {
          if (gal._vmfDS && !dataSource) {
            var ds = lb.options.dataSource || [];
            var i = ds.findIndex(function (x) { return String(x.id) === String(index); });
            index = i < 0 ? 0 : i;
          }
          return origOpen(index, dataSource, point);
        };
      }
      if (this.lightbox && this.lightbox.options) {
        if (!this._vmfDS) this._vmfDS = (this.lightbox.options.dataSource || []).slice();
        var full = this._vmfDS, w = this.vmfWrappers()[0];
        if (w) {
          var ds = [];
          Array.prototype.forEach.call(w.children, function (el) {
            var src = full.filter(function (x) { return String(x.id) === String(el.dataset.mediaIndex); })[0];
            if (src) ds.push(src);
          });
          this.lightbox.options.dataSource = ds;
        }
      }
    };

    P.vmfSlideToFeatured = function (f) {
      var s = this.sliderInstance && this.sliderInstance.slider;
      var w = this.vmfWrappers()[0];
      if (!s || !w || !f) return false;
      var idx = Array.prototype.findIndex.call(w.children, function (el) { return String(el.dataset.mediaId) === String(f); });
      s.slideTo(Math.max(0, idx), 0, false);
      return true;
    };

    P.init = function () {
      var was = this.initialized;
      var r = origInit.apply(this, arguments);
      if (was || !this.vmfData()) return r;
      var d = this._vmfData;
      var self = this;
      var vid = d.selected;
      try { var q = new URL(location.href).searchParams.get('variant'); if (q && d.variants[q] !== undefined) vid = q; } catch (e) {}
      var f = this.vmfApply(vid);
      if (f && /[?&]variant=/.test(location.search)) this.vmfSlideToFeatured(f);
      return r;
    };

    P.setActiveMedia = function (variant) {
      if (variant && this.vmfData()) {
        if (!this.initialized) this.init();
        var f = this.vmfApply(variant.id);
        if (f && this.vmfSlideToFeatured(f)) return;
      }
      return origSet.apply(this, arguments);
    };

    P.sortMediaItems = function (variant, featuredMedia) {
      var r = origSort.apply(this, arguments);
      if (variant && this.vmfData()) this.vmfApply(variant.id);
      return r;
    };

    document.querySelectorAll('media-gallery').forEach(function (g) {
      if (g.initialized && !g._vmfVariant && g.vmfData()) {
        var dd = g._vmfData, f = g.vmfApply(dd.selected);
        if (f && /[?&]variant=/.test(location.search)) g.vmfSlideToFeatured(f);
      }
    });
    return true;
  }
  if (!patch()) {
    customElements.whenDefined('media-gallery').then(patch);
  }
})();
